export interface Settings {
	team: string;
	styleClass: {
		items: string;
		links: string;
		bios: string;
	};
}

export default class TeamLanding {
	private readonly team: HTMLElement;
	private settings: Settings;
	private windowWidth: Number;
	private links: NodeListOf<any>;
	private selectedItem: HTMLElement;
	private selectedBio: HTMLElement;
	private previousItem: HTMLElement;
	private previousBio: HTMLElement;
	private displayedBio: HTMLElement;
	private dataAttr: string = 'data-active';

	private resizeHandler = (event?: Event) => {
		this.windowWidth = this.windowWidth || window.innerWidth;
		if (this.windowWidth !== window.innerWidth){
			this.windowWidth = window.innerWidth;
			this.reset();
		}
	}
	private closeClickHandler = (event?: Event) => {
		if (event) {
			event.preventDefault();
		}
		this.previousItem = this.selectedItem || null;
		this.reset();
	}
	private itemClickHandler = (event: Event) => {
		event.preventDefault();
		let target = (event.target as HTMLElement);
		if (target.parentElement == this.selectedItem) {
			return;
		}

		this.previousItem = this.selectedItem || null;
		this.selectedItem = target.parentElement;

		const hash = TeamLanding.getHash(target.getAttribute('href'));
		this.selectedBio = document.getElementById(decodeURI(hash));

		if (this.previousItem) {
			this.deactivate();
			window.setTimeout(() => {
				this.previousBio.remove();
				this.displayedBio = null;
				this.activate();
			}, 50); // was 200
		} else {
			this.activate();
		}
	}
	private activate = () => {
		this.selectBio();
		this.placeBio();
		// This timeout needs a delay
		window.setTimeout(() => {
			this.selectedItem.setAttribute(this.dataAttr, 'true');
			this.displayedBio.setAttribute(this.dataAttr, 'true');
		}, 50); // was 50
		window.setTimeout(() => {
			window.scrollTo({
				left: 0,
				top: window.scrollY + this.selectedItem.getBoundingClientRect().top,
				behavior: 'smooth'
			});
		}, 50); // was 400
	}
	private deactivate = () => {
		if (this.previousItem) {
			this.previousItem.removeAttribute(this.dataAttr);
		}
		if (this.displayedBio) {
			this.displayedBio.removeAttribute(this.dataAttr);
			this.previousBio = this.displayedBio;
		}
	}
	private reset = () => {
		if (this.displayedBio) {
			this.displayedBio.removeAttribute(this.dataAttr);
		}
		if (this.previousItem) {
			this.previousItem.removeAttribute(this.dataAttr);
		}
		if (this.selectedItem) {
			this.selectedItem.removeAttribute(this.dataAttr);
		}
		window.setTimeout(() => {
			if (this.displayedBio) {
				this.displayedBio.remove();
			}
			this.displayedBio = null;
			this.previousItem = null;
			this.selectedItem = null;
		}, 200); // was 200
	}
	private static getHash(string: String) {
		return string.split('#')[1];
	}
	private selectBio = () => {
		let clone = this.selectedBio.cloneNode(true) as HTMLElement;
		clone.removeAttribute('id');
		clone.querySelector('footer a').addEventListener("click", (event: Event) => {
			this.closeClickHandler(event)
		});
		this.displayedBio = clone;
	}
	private placeBio = () => {
		const currtop = this.selectedItem.offsetTop;
		let nexttop = this.selectedItem.offsetTop;
		let nextItem = this.selectedItem as any;
		do {
			nextItem = nextItem.nextElementSibling;
			if (nextItem) {
				nexttop = nextItem.offsetTop;
			} else {
				break;
			}
		} while (nexttop == currtop);

		this.selectedItem.parentElement.insertBefore(this.displayedBio, nextItem);
	}
	constructor(settings: Settings) {
		this.team = document.querySelector(`${settings.team}`);
		if (!this.team) {
			return;
		}
		this.settings = settings;
		this.links = this.team.querySelectorAll(`${settings.styleClass.links}`);
		for (let i = 0; i < this.links.length; i++) {
			this.links[i].addEventListener("click", this.itemClickHandler);
		}
		window.addEventListener("resize", this.resizeHandler, true);
	}
}